// extracted by mini-css-extract-plugin
module.exports = {"CircleWrapper":"LoadingCircle_CircleWrapper__DmxXj","DashedCircle":"LoadingCircle_DashedCircle__V8kSq"};